import React, {useEffect, useState} from 'react';
import {fetchWhitelabelFolders, fetchWhitelableZip} from "../services/awsHandler";
import usePrivacy from "../services/usePrivacy";
import orderBy from "lodash-es/orderBy";
import dayjs from "dayjs";

const WhitelabelsDisplay = (props) => {
    const { } = props;
    const [whiteLabels, setWhiteLabels] = useState([]);
    const ready = usePrivacy()

    useEffect(() => {
        if(ready) fetchWhitelabels()
    }, [ready]);

    const fetchWhitelabels = async () => {
        const res = await fetchWhitelabelFolders()
        const sortedByDate = orderBy(res, [(item) => {
            if (!item.submitDate) return -Infinity;
            const [day, month, year] = item.submitDate.split('-');
            return new Date(`${year}-${month}-${day}`).getTime();
        }, 'appName'], ['desc', 'asc'])
        console.log('fetchWhitelabels', sortedByDate)
        setWhiteLabels(sortedByDate)
    }

    return (
        <div style={{direction: 'ltr', display: 'flex', flexDirection: 'column', gap: '10px', margin: '10px'}}>
            <span style={{fontSize: '24px', fontWeight: 'bold'}}>Whitelabels</span>
            <span style={{fontSize: '18px'}}>Click on a whitelabel to download zip file</span>
            <table style={{width: '100%', borderCollapse: 'collapse', marginTop: '10px'}}>
                <thead>
                <tr>
                    <th style={{textAlign: 'left', padding: '10px', borderBottom: '1px solid #ddd'}}>App Name</th>
                    <th style={{textAlign: 'left', padding: '10px', borderBottom: '1px solid #ddd'}}>Submit Date</th>
                    <th style={{textAlign: 'left', padding: '10px', borderBottom: '1px solid #ddd'}}>Business Email</th>
                </tr>
                </thead>
                <tbody>
                {whiteLabels.map((whiteLabel) => (
                    <tr key={whiteLabel.folderName}>
                        <td
                            style={{cursor: 'pointer', padding: '10px', borderBottom: '1px solid #ddd'}}
                            onClick={() => fetchWhitelableZip(whiteLabel.folderName)}
                        >
                            {whiteLabel.appName}
                        </td>
                        <td style={{padding: '10px', borderBottom: '1px solid #ddd'}}>
                            {whiteLabel.submitDate || 'N/A'}
                        </td>
                        <td style={{padding: '10px', borderBottom: '1px solid #ddd'}}>
                            {whiteLabel.businessEmail || 'N/A'}
                        </td>
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
    );
};

export default WhitelabelsDisplay;